import * as React from "react"
import { Block } from "./library/container"

export interface HighlightBlockProps {
  readonly kind: "highlight"
  readonly title: string
  readonly subtitle: string
  readonly content: string
}

export const HighlightBlock: (props: HighlightBlockProps) => JSX.Element = p => (
  <Block>
    <div className="highlight container--sg align--center">
      <h2 className="highlight__title title--l">{p.title}</h2>
      <div className="highlight__subtitle text--m">{p.subtitle}</div>
      <div className="highlight__text text--styled" dangerouslySetInnerHTML={{ __html: p.content }} />
    </div>
  </Block>
)

{/* TH: Added to styleguide! */}

